import { combineReducers } from '@reduxjs/toolkit'

import smtStencil  from 'product_tabs/tab_smt_stencils/stencilSlice'
import bom from 'product_tabs/tab_parts/bomSlice';
import tab from 'product_tabs/tabs/tabSlice';
import alert from 'product_tabs/alerts/alertSlice';
import fabrication  from './pcb_fabrication/fabricationSlice'
import accessories from 'product_tabs/tab_accessories/accessoriesSlice';
import assembly from 'product_tabs/tab_assembly/assemblySlice';

const rootReducer = combineReducers({
  fabrication,
  smtStencil,
  bom,
  tab,
  alert,
  accessories,
  assembly,
});

export default rootReducer
